import React from 'react';
export const LongArrowLeft = ({ ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='8.003'
      viewBox='0 0 12 8.003'
      {...props}
    >
      <path
        data-name='_ionicons_svg_ios-arrow-round-back (2)'
        d='M116.447,160.177a.545.545,0,0,1,0,.767l-2.53,2.538h9.641a.542.542,0,0,1,0,1.084h-9.641l2.534,2.538a.549.549,0,0,1,0,.767.54.54,0,0,1-.763,0l-3.435-3.46a.608.608,0,0,1-.113-.171.517.517,0,0,1-.042-.208.543.543,0,0,1,.154-.379l3.435-3.46A.531.531,0,0,1,116.447,160.177Z'
        transform='translate(-112.1 -160.023)'
        fill='currentColor'
      />
    </svg>
  );
};
